import authAxios, { authHeader } from "./data";

const createVisit = async (request: any) => {
  const result = await authAxios.post("/api/Analitics/visits", request, {
    headers: authHeader(),
  });

  return result.data;
};

const AnaliticsService = {
  createVisit,
};

export default AnaliticsService;
